import React, { useState } from "react";
import { Plus, Search, Trash2, Pencil, Pin, MessageSquare, X } from "lucide-react";

export function Sidebar({ conversations, activeId, onSelect, onNew, onRename, onDelete, onPin, onSearch, open, onClose }) {
  const [editing, setEditing] = useState(null);
  const [editValue, setEditValue] = useState("");
  const [query, setQuery] = useState("");

  const submitRename = (id) => {
    if (editValue.trim()) onRename(id, editValue.trim());
    setEditing(null);
  };

  return (
    <>
      {open && <div className="fixed inset-0 bg-black/50 z-30 lg:hidden" onClick={onClose} />}
      <aside
        data-testid="conversation-sidebar"
        className={`fixed lg:static z-40 top-0 left-0 h-full w-72 shrink-0 glass-panel lg:bg-transparent lg:backdrop-blur-none lg:border-0 lg:shadow-none transition-transform duration-300 ${open ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}
      >
        <div className="h-full flex flex-col p-4">
          <div className="flex items-center justify-between mb-4">
            <div className="label-mono">Conversations</div>
            <button className="lg:hidden text-slate-400" onClick={onClose}><X className="w-5 h-5" /></button>
          </div>

          <button
            data-testid="sidebar-new-chat-button"
            onClick={onNew}
            className="w-full rounded-full py-2.5 flex items-center justify-center gap-2 text-sm font-medium text-[#000000] mb-3"
            style={{ background: "linear-gradient(90deg, #FFFFFF, #C8C8C8)" }}
          >
            <Plus className="w-4 h-4" /> New conversation
          </button>

          <div className="relative mb-3">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
            <input
              data-testid="sidebar-search-input"
              value={query}
              onChange={(e) => { setQuery(e.target.value); onSearch(e.target.value); }}
              placeholder="Search"
              className="w-full rounded-xl bg-[#0D0D0D] border border-white/10 pl-9 pr-3 py-2 text-sm outline-none focus:border-mono-400/50"
            />
          </div>

          <div className="flex-1 overflow-y-auto thin-scroll space-y-1" data-testid="conversation-history-list">
            {conversations.length === 0 && <div className="text-sm text-slate-500 px-2 py-4">No conversations yet.</div>}
            {conversations.map((c) => (
              <div
                key={c.id}
                data-testid="conversation-item"
                className={`group rounded-xl px-3 py-2.5 cursor-pointer border transition-all ${activeId === c.id ? "border-mono-400/40 bg-mono-400/5" : "border-transparent hover:bg-white/5"}`}
                onClick={() => onSelect(c.id)}
              >
                {editing === c.id ? (
                  <input
                    autoFocus value={editValue}
                    onChange={(e) => setEditValue(e.target.value)}
                    onBlur={() => submitRename(c.id)}
                    onKeyDown={(e) => e.key === "Enter" && submitRename(c.id)}
                    onClick={(e) => e.stopPropagation()}
                    className="w-full bg-transparent border-b border-mono-400/50 text-sm outline-none"
                    data-testid="conversation-rename-input"
                  />
                ) : (
                  <div className="flex items-center gap-2">
                    {c.pinned ? <Pin className="w-3.5 h-3.5 text-mono-400 shrink-0" /> : <MessageSquare className="w-3.5 h-3.5 text-slate-500 shrink-0" />}
                    <span className="text-sm truncate flex-1">{c.title}</span>
                    <span className={`text-[10px] px-1.5 py-0.5 rounded-full ${c.assistant === "sam" ? "text-mono-300 bg-mono-500/10" : "text-mono-300 bg-mono-500/10"}`}>{c.assistant === "sam" ? "Sam" : "Anna"}</span>
                  </div>
                )}
                <div className="hidden group-hover:flex items-center gap-3 mt-2 pl-5">
                  <button data-testid="conversation-pin" onClick={(e) => { e.stopPropagation(); onPin(c); }} className="text-slate-500 hover:text-mono-300"><Pin className="w-3.5 h-3.5" /></button>
                  <button data-testid="conversation-rename" onClick={(e) => { e.stopPropagation(); setEditing(c.id); setEditValue(c.title); }} className="text-slate-500 hover:text-mono-300"><Pencil className="w-3.5 h-3.5" /></button>
                  <button data-testid="conversation-delete" onClick={(e) => { e.stopPropagation(); onDelete(c.id); }} className="text-slate-500 hover:text-red-400"><Trash2 className="w-3.5 h-3.5" /></button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </aside>
    </>
  );
}
